import { useMediaQuery } from '@material-ui/core';
import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { BEHAVIOR } from '../constants';

const useTwilioDesktop = () => {
  const isDesktop = useMediaQuery(`(min-width: ${BEHAVIOR.MOBILE_BREAKPOINT + 1}px)`);
  const isLargeDesktop = useMediaQuery(`(min-width: ${BEHAVIOR.LARGE_DESKTOP_BREAKPOINT}px)`);
  const { pathname } = useLocation();

  const isBoothProfilePage = useMemo(() => pathname.startsWith('/booth'), [pathname]);

  return useMemo(() => ({
    isDesktop: isBoothProfilePage ? isLargeDesktop : isDesktop,
    isBoothProfilePage,
  }), [isDesktop, isLargeDesktop, isBoothProfilePage]);
};

export default useTwilioDesktop;
